import {createAction} from 'redux-actions';
import {ARTICLE_ADDON_CHECKBOX_INPUT_TOGGLE, ARTICLE_ADDON_SKU_SET} from '../../../action-types';

export const toggleCheckboxInput = createAction(ARTICLE_ADDON_CHECKBOX_INPUT_TOGGLE);

export const setSku = createAction(ARTICLE_ADDON_SKU_SET, (article, sku) => ({
	active: v12.article.sku(article, sku),
	article
}));
